module.exports = __webpack_public_path__ + "img/circle2red.462e239b.png";